var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHowStep1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "150px",
    height: "150px",
    viewBox: "0 0 150 150",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons / how-step-1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-17.6%",
    y: "-17.6%",
    width: "135.2%",
    height: "135.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 3,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.3 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "11.9805992%",
    y1: "15.1651008%",
    x2: "71.8466621%",
    y2: "93.3403753%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC124",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89422",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "50%",
    x2: "0%",
    y2: "50%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC3E7F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E286D",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M69.9431667,20.9057778 L69.9399444,0 L51.0432222,18.8967222 L46.8382222,35.9100556 L18.1475556,64.5991111 C16.7056111,64.0755 15.1589444,63.7758333 13.5365556,63.7758333 C6.061,63.7758333 0,69.8368333 0,77.3123889 C0,84.7879444 6.06261111,90.8489444 13.5365556,90.8489444 C21.0137222,90.8489444 27.0731111,84.7863333 27.0731111,77.3123889 C27.0731111,75.69 26.7734444,74.1417222 26.2498333,72.7013889 L54.9388889,44.0123333 L71.9538333,39.8057222 L90.8489444,20.909 L69.9431667,20.9057778 Z",
    id: "path-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "56.9004782%",
    x2: "29.4347575%",
    y2: "84.3088619%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "41.5324059%",
    y1: "44.4856839%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFCFCF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons-/-how-step-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_Target_40338",
    filter: "url(#filter-1)",
    transform: "translate(2.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.0763333,77.3123889 C27.0763333,99.7406667 45.2593333,117.923667 67.6876111,117.923667 C90.1158889,117.923667 108.298889,99.7406667 108.298889,77.3123889 C108.298889,71.1627778 106.924611,65.3353889 104.478944,60.1121667 L93.9358333,70.6552778 C94.4739444,72.7851667 94.7639444,75.0149444 94.7639444,77.3123889 C94.7639444,92.2635 82.6403333,104.387111 67.6876111,104.387111 C52.7348889,104.387111 40.6128889,92.2651111 40.6128889,77.3123889 C40.6128889,62.3596667 52.7348889,50.2360556 67.6876111,50.2360556 C69.9850556,50.2360556 72.2148333,50.5260556 74.3447222,51.0641667 L84.8878333,40.5210556 C79.6646111,38.0737778 73.8388333,36.7011111 67.6876111,36.7011111 C45.2593333,36.7011111 27.0763333,54.8841111 27.0763333,77.3123889 Z",
    id: "Path",
    fill: "url(#linearGradient-2)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path-30",
    transform: "translate(54.151056, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-5",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "url(#linearGradient-3)",
    fillRule: "nonzero",
    xlinkHref: "#path-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.09899,-1.36849126 L114.09899,-26.400443 L5.34894444,88.6386634 C61.1971679,97.0216622 97.447183,97.6421078 114.09899,90.5 C130.750796,83.3578922 130.750796,52.7350618 114.09899,-1.36849126 Z",
    fillOpacity: 0.15,
    fill: "url(#linearGradient-6)",
    mask: "url(#mask-5)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 9.624778)",
    fillRule: "nonzero",
    id: "Path"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#000000",
    points: "128.337889 39.4335556 115.655222 42.5687778"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.337889,39.4335556 L128.337889,39.4335556 L115.655222,42.5687778 C119.596,50.0781667 121.837056,58.6186667 121.837056,67.6876111 C121.837056,97.5914444 97.5914444,121.837056 67.6876111,121.837056 C37.7837778,121.837056 13.5381667,97.5898333 13.5381667,67.6876111 C13.5381667,37.7821667 37.7853889,13.5381667 67.6876111,13.5381667 C76.7565556,13.5381667 85.2970556,15.7808333 92.8064444,19.72 L95.9416667,7.03733333 L95.9416667,7.03733333 L96.1317778,6.26883333 C87.4817222,2.25555556 77.8505,-2.86190824e-15 67.6876111,-2.86190824e-15 C30.3066111,0.00161111111 0,30.3066111 0,67.6876111 C0,105.068611 30.3066111,135.375222 67.6876111,135.375222 C105.068611,135.375222 135.375222,105.068611 135.375222,67.6876111 C135.375222,57.5231111 133.122889,47.8918889 129.106389,39.2434444 L128.337889,39.4335556 Z",
    fill: "url(#linearGradient-7)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000000",
    points: "92.8064444 19.72 95.9416667 7.03733333 95.9416667 7.03733333"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowStep1);
export default __webpack_public_path__ + "static/media/how-step-1.a5cd950dc7fbc9ff50b16eb48ea0a1fc.svg";
export { ForwardRef as ReactComponent };